import PropTypes from 'prop-types'

// Utils
import convertDataToContent from '../../utils/data/convertDataToContent'

const RichTextBlock = (props) => {
  const { data, content, modifiers } = props

  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  const getHtml = () => {
    const source = data && !content ? convertDataToContent(data) : content
    return parseHtml(source && typeof source === 'object' ? source.html : source)
  }

  const parseHtml = (content) => {
    return { __html: content }
  }

  return <div className={`RichTextBlock${modifierClasses}`} dangerouslySetInnerHTML={getHtml()}></div>
}

RichTextBlock.propTypes = {
  data: PropTypes.array,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  modifiers: PropTypes.array
}

export default RichTextBlock
